const initialState = {
  users: [],
  usersLoading: false,
  // The top-bar selection the user list was last asked for.
  usersRequestKey: null,
  settings: null,
  // The user + top-bar selection whose settings were last asked for. Answers
  // for anything else are stale (the picker or top bar moved on) and dropped.
  requestKey: null,
  loading: false,
  saving: false,
  error: null,
  vehicleSearch: {
    organizationId: null,
    search: '',
    results: [],
    loading: false,
  },
};

function keyOf(action) {
  return action.additionalData ? action.additionalData.requestKey : null;
}

function isForRequestedUser(state, action) {
  return keyOf(action) === state.requestKey;
}

export default function (state = initialState, action) {
  switch (action.type) {
    case 'FETCH_NOTIFICATION_SETTINGS_USERS_REQUEST':
      return {
        ...state, usersLoading: true, users: [], usersRequestKey: keyOf(action),
      };
    case 'FETCH_NOTIFICATION_SETTINGS_USERS_SUCCESS':
      if (keyOf(action) !== state.usersRequestKey) {
        return state;
      }
      return { ...state, usersLoading: false, users: action.payload };
    case 'FETCH_NOTIFICATION_SETTINGS_USERS_FAIL':
      if (keyOf(action) !== state.usersRequestKey) {
        return state;
      }
      return { ...state, usersLoading: false, users: [] };

    case 'FETCH_NOTIFICATION_SETTINGS_REQUEST':
      return {
        ...state,
        requestKey: keyOf(action),
        loading: true,
        error: null,
        vehicleSearch: initialState.vehicleSearch,
      };
    case 'FETCH_NOTIFICATION_SETTINGS_SUCCESS':
      if (!isForRequestedUser(state, action)) {
        return state;
      }
      return { ...state, loading: false, settings: action.payload };
    case 'FETCH_NOTIFICATION_SETTINGS_FAIL':
      if (!isForRequestedUser(state, action)) {
        return state;
      }
      return { ...state, loading: false, settings: null, error: action.payload };

    case 'UPDATE_NOTIFICATION_SETTING_REQUEST':
      return { ...state, saving: true };
    case 'UPDATE_NOTIFICATION_SETTING_SUCCESS':
      if (!isForRequestedUser(state, action)) {
        return { ...state, saving: false };
      }
      return {
        ...state,
        saving: false,
        settings: action.payload,
        vehicleSearch: initialState.vehicleSearch,
      };
    case 'UPDATE_NOTIFICATION_SETTING_FAIL':
      return { ...state, saving: false };

    case 'SEARCH_NOTIFICATION_VEHICLES_REQUEST':
      return {
        ...state,
        vehicleSearch: {
          organizationId: action.additionalData.organizationId,
          search: action.additionalData.search,
          results: state.vehicleSearch.results,
          loading: true,
        },
      };
    case 'SEARCH_NOTIFICATION_VEHICLES_SUCCESS':
      // Only the answer to the latest search counts.
      if (action.additionalData.search !== state.vehicleSearch.search
        || action.additionalData.organizationId !== state.vehicleSearch.organizationId) {
        return state;
      }
      return {
        ...state,
        vehicleSearch: { ...state.vehicleSearch, results: action.payload, loading: false },
      };
    case 'SEARCH_NOTIFICATION_VEHICLES_FAIL':
      return {
        ...state,
        vehicleSearch: { ...state.vehicleSearch, results: [], loading: false },
      };
    case 'CLEAR_NOTIFICATION_VEHICLE_SEARCH':
      return { ...state, vehicleSearch: initialState.vehicleSearch };

    default:
      return state;
  }
}
